import React, { useContext } from "react";

import AuthContext from "shared/providers/context/AuthContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import DocumentInput from "@CheckoutOnepageOffers/components/atoms/DocumentInput";
import Input, {
  WrapperInputs,
} from "@CheckoutOnepageOffers/components/atoms/Input";
import InputMask from "@CheckoutOnepageOffers/components/atoms/InputMask";
import PhoneInputCountry from "@CheckoutOnepageOffers/components/atoms/PhoneInputCountry";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { Scope } from "@unform/core";

import { PersonalDataSection } from "./styles";

const PersonalData = ({ inputError, setInputError }) => {
  const { state } = useGlobalContext();
  const { loggedUser } = useContext(AuthContext);
  const { country } = useCheckoutContext();

  const emailFieldRegex = /[^a-zA-Zs0-9@._-]/g;

  const { create_account_options } = state?.tenancy;

  return (
    <PersonalDataSection>
      <Scope path="user">
        <WrapperInputs>
          <Input
            required
            name="name"
            label="Nome completo"
            placeholder="Digite o seu nome e sobrenome"
          />
        </WrapperInputs>

        {!loggedUser && (
          <WrapperInputs>
            <Input
              required
              name="email"
              label="E-mail"
              replace={emailFieldRegex}
              placeholder="Digite o e-mail"
            />
          </WrapperInputs>
        )}

        <WrapperInputs>
          {country === "Brasil" && (
            <DocumentInput
              required
              name="document"
              label="CPF ou CNPJ do Titular"
              placeholder="Digite o seu CPF ou CNPJ"
              inputError={inputError}
              setInputError={setInputError}
            />
          )}
          <PhoneInputCountry />
        </WrapperInputs>

        {!loggedUser &&
          create_account_options?.request_custom_fields_to_create_account &&
          create_account_options?.custom_fields_active?.map((field) => (
            <WrapperInputs key={field?.name}>
              <Input
                required={field?.required}
                name={field?.name}
                label={field?.label}
                placeholder={field?.placeholder}
              />
            </WrapperInputs>
          ))}
      </Scope>
    </PersonalDataSection>
  );
};

export default PersonalData;
